import { DashboardWidgetData } from 'features/widget/types'
import { AnnotatedMediaMetricResult } from '../../types'

// eslint-disable-next-line import/prefer-default-export
export const retrieveMetrics = (response: DashboardWidgetData<AnnotatedMediaMetricResult>) =>
  response?.results?.[0].data.metrics || []
